import script from "./MasterTestManager.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterTestManager.vue?vue&type=script&setup=true&lang=js"

import "./MasterTestManager.vue?vue&type=style&index=0&id=2cfa1d7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfa1d7f"]])

export default __exports__